export default __webpack_public_path__ + "static/media/dump-truck.d1557aed.png";